import { useNotificationStore } from '../store';
import { NotificationStatus } from '../types';

export function useNotificationStatus(status?: NotificationStatus) {
  const isNew = status === NotificationStatus.SENT;
  const isRead = status === NotificationStatus.DELIVERED;
  const isArchived = status === NotificationStatus.ARCHIVED;
  return { isNew, isRead, isArchived };
}

export function useNotificationNewStatus(
  notificationId?: string,
  status?: NotificationStatus
) {
  const seenNotifications = useNotificationStore.useSeenNotifications();

  const isNewlyAdded =
    notificationId &&
    status === NotificationStatus.SENT &&
    !seenNotifications.has(notificationId);

  return { isNewlyAdded };
}
